import React from 'react';
import { Helmet } from 'react-helmet-async';
import DetailsContainer from 'Components/details/DetailsContainer';


const Details = () => {


  return (
    <React.StrictMode>
      <Helmet>
        <title>Details</title>
      </Helmet>
      <DetailsContainer />

    </React.StrictMode>
  )
};


export default Details;
